import React from 'react';
import { Toast, ToastBody } from 'reactstrap';

import "./toast.scss";

const CustomToast = (props) => {
  const { className, message } = props;
  return (
    <Toast className={className}>
      <ToastBody>
        {message}
      </ToastBody>
    </Toast>
  );
};

export default CustomToast;